import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './LoginForm.styles';

import FormError from '../formerror/FormError';
import Image from '../../common/image/Image';
import LoginButton from '../../inputs/loginbutton/LoginButton';
import LoginInput from '../../inputs/logininput/LoginInput';

export class LoginFormDomain extends Component {
  render() {
    const { loginError } = this.props;
    return (
      <form className={css(styles.form)} onSubmit={this.props.handleSubmit}>
        <Image src="https://www.airfinder.com/hubfs/AirFinderAssetv3/AirFinder-v3-logo-white.svg" 
          alt="logo" styles={styles.logo} />
        <Field
          name="username"
          type="text"
          placeholder={I18n.t('login.username')}
          component={LoginInput}
        />
        {loginError && (
          <FormError title={I18n.t('login.errorTitle')}>
            {I18n.t('login.errorBody')}
          </FormError>
        )}
        <div className={css(styles.actions, loginError && styles.actionsError)}>
          <LoginButton>{I18n.t('login.next')}</LoginButton>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'login'
})(LoginFormDomain);



// WEBPACK FOOTER //
// ./src/components/forms/loginform/LoginFormDomain.js